const isOptimeringPage = (page) =>
  page &&
  (page.href === 'optimering' ||
    page.href === '/admin/optimering' ||
    (typeof page.href === 'string' && page.href.endsWith('/optimering')));

const findOptimeringItem = (menu) => {
  if (!Array.isArray(menu)) return null;
  for (let i = 0; i < menu.length; i += 1) {
    const section = menu[i];
    if (section && Array.isArray(section.pages)) {
      const match = section.pages.find(isOptimeringPage);
      if (match) return match;
    }
  }
  return null;
};

const updateOptimizationMenuCounts = (menu, counts) => {
  const menuItem = findOptimeringItem(menu);
  if (!menuItem || !Array.isArray(menuItem.children)) {
    return menu;
  }
  menuItem.children.forEach((value, i) => {
    // eslint-disable-next-line no-param-reassign
    value.title = `${value.title.split('(')[0]}(${(counts && counts[i]) || 0})`;
  });
  return menu;
};

module.exports = {
  updateOptimizationMenuCounts,
};
